import { ListingType, NFTItem, PaymentMethodType } from "./types";

export const displayPrice = (item: NFTItem) =>
  item.listingPrice
    ? `${(
        Number(item.listingPrice) /
        10 ** Number(item.paymentMethod?.decimal || 0)
      ).toFixed(Number(item.paymentMethod?.decimal || 0))} ${
        item.paymentMethod?.name
      }`
    : "";

export const displayPriceFromListing = (
  item: ListingType,
  paymentMethod: PaymentMethodType
): string =>
  item.listingPrice
    ? `${(
        Number(item.listingPrice) /
        10 ** Number(paymentMethod.decimal || 0)
      ).toFixed(Number(paymentMethod.decimal || 0))} ${
        paymentMethod.name || ""
      }`
    : "";
